import { Component, OnInit } from '@angular/core';
import { BaseComponent } from 'app/modules/shared/components/base.component';

@Component({
  selector: 'page-schedule-registration',
  templateUrl: './schedule-registration.component.html',
  styleUrls: ['./schedule-registration.component.scss'],
})
export class PractitionerScheduleRegistrationComponent extends BaseComponent implements OnInit {
  ngOnInit(): void {}
}
